import { useState } from "react";
import Button from "../Button/Button";
import classes from "./Hyperwebster.module.scss";

export default function Hyperwebster(props) {
  const [pressed, setPressed] = useState(0);

  return pressed !== 0 ? (
    <div className={classes.ubi}>
      <div className={classes.bold}>
        Has {pressed} nth place in Hyperwebster
      </div>
    </div>
  ) : (
    <div className={classes.ubi}>
      <div className={classes.bold}>
        {"Look up a word in the current Hyperwebster"}
      </div>
      <div>
        <input className={classes.input}></input>
        <Button text="Go" onClick={() => setPressed(Math.random())} />
      </div>
    </div>
  );
}
